export default {"src":"/_next/static/media/vpage-resources.f417e176.gif","height":316,"width":562,"blurWidth":0,"blurHeight":0};